import type { ClubEventType } from '../../types'

export interface EventTypeMeta {
  value: ClubEventType
  label: string
  /** Tailwind classes for the type badge */
  chip: string
}

// Combined-calendar event types. Liberation is first-class (race liberations
// were a specific club ask), races/meetings/socials/announcements round it out.
export const EVENT_TYPES: EventTypeMeta[] = [
  { value: 'race', label: 'Race', chip: 'bg-secondary text-white' },
  { value: 'liberation', label: 'Liberation', chip: 'bg-amber-500 text-white' },
  { value: 'meeting', label: 'Meeting', chip: 'bg-primary text-white' },
  { value: 'social', label: 'Social', chip: 'bg-emerald-600 text-white' },
  { value: 'announcement', label: 'Announcement', chip: 'bg-slate-600 text-white' },
  { value: 'other', label: 'Other', chip: 'bg-slate-400 text-white' },
]

export function eventMeta(type: string): EventTypeMeta {
  return EVENT_TYPES.find((t) => t.value === type) ?? EVENT_TYPES[EVENT_TYPES.length - 1]
}

/** Parse a YYYY-MM-DD string as a LOCAL date (avoids UTC off-by-one). */
export function parseLocalDate(d: string): Date {
  const [y, m, day] = d.split('-').map(Number)
  return new Date(y, (m || 1) - 1, day || 1)
}
